import React from 'react';
import {Box, Typography} from '@mui/material';

import logoImage from '../../../assets/icons/logo.svg';
import { appTheme } from './theme';
import DefaultTitle from './DefaultTitle';


interface IAuthViewHeaderProps {
  title?: React.ReactNode;
  subtitle?: string;
}

const DEFAULT_SUBTITLE = 'Streamline data, amplify results';
/**
 * Common header to login views
 */
export const AuthViewHeader: React.FC<IAuthViewHeaderProps> = (props) => {
  return (
    <>
      <Box
        component="img"
        src={logoImage}
        sx={{
          width: 60,
          height: 60,
          marginBottom: appTheme.spacing(10),
          justifyContent: 'center',
          alignItems: 'center'
        }}
      />

      <Typography
        sx={{
          fontSize: 36,
          lineHeight: '44px',
          fontWeight: 400,
          color: '#fff',
        }}
      >
        {props.title ? props.title : <DefaultTitle />}
      </Typography>
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 400,
          marginTop: appTheme.spacing(4),
          color: appTheme.palette.text.secondary
        }}
      >
        {props.subtitle ? props.subtitle : DEFAULT_SUBTITLE}
      </Typography>
    </>
  );
};

export default AuthViewHeader;